import React, { useState } from "react";
import { Link } from "react-router-dom";
import { imgSrc } from "../utils/images";

export default function CategoryButton({ cat, to, active = false, onClick }) {
  const label = String(cat?.label || "Category");
  const rawImg = String(cat?.image_path || "").trim();
  const initial = label.trim().slice(0, 2).toUpperCase();

  const [imgOk, setImgOk] = useState(Boolean(rawImg));
  const url = rawImg ? imgSrc(rawImg) : "";

  return (
    <Link
      to={to}
      onClick={onClick}
      className={`catBtn ${active ? "catBtnActive" : ""}`}
      title={label}
      aria-current={active ? "page" : undefined}
    >
      <span className="catIcon">
        {imgOk ? (
          <img
            className="catIconImg"
            src={url}
            alt=""
            onError={() => setImgOk(false)}
          />
        ) : (
          <span className="catIconTxt">{initial}</span>
        )}
      </span>
      <span className="catBtnLabel">{label}</span>
    </Link>
  );
}
